import { render, staticRenderFns } from "./SortableTextList.vue?vue&type=template&id=1a79ad7c&"
import script from "./SortableTextList.vue?vue&type=script&lang=js&"
export * from "./SortableTextList.vue?vue&type=script&lang=js&"
import style0 from "./SortableTextList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports